/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export const getConversionRedirect = (
  token: string,
  agreementId?: string,
  productId?: string,
): string => {
  const encodedToken = decodeURIComponent(token).replace(/ /g, '+')
  let redirect = `/marketplace-conversion#token=${encodedToken}&partner=aws`

  // When AWS QuickLaunch is disabled, the agreementId and productId are not sent to
  // Elastic so we are making these optional so we don't block the signup flow.
  if (agreementId) {
    const encodedAgreementId = decodeURIComponent(agreementId).replace(/ /g, '+')
    redirect += `&agreementId=${encodedAgreementId}`
  }

  if (productId) {
    const encodedProductId = decodeURIComponent(productId).replace(/ /g, '+')
    redirect += `&productId=${encodedProductId}`
  }

  return redirect
}
